'use client'
import { apiResponseHandler } from '@/shared/api/react-query'
import { useMutation } from '@tanstack/react-query'
import { useEffect } from 'react'
import { toast } from '@/shared/ui/use-toast'
import services from '../services'
import { CreateProject, createProjectMappers } from '../../lib'
import { useGetProjectId } from '@/app/slugs'

const useHook = (params?: { onSuccess?: (data: CreateProject) => void }) => {
  const { projectId } = useGetProjectId()
  const mutaion = useMutation({
    mutationFn: async (payload: Partial<CreateProject>) => {
      const mappedPayload = createProjectMappers.mapCreateProjectToDto(payload)
      return apiResponseHandler(await services.updateProject({ ...mappedPayload, projectId }))
    },
    onSuccess: (data) => {
      params?.onSuccess && params.onSuccess(createProjectMappers.mapCreateProject(data || {}))
      toast({
        title: 'Вы успешно обновили проект!',
      })
    },
  })

  useEffect(() => {
    if (mutaion.isError) console.error(mutaion.error)
  }, [mutaion.error, mutaion.isError])

  const muationResult = {
    ...mutaion,
    data: createProjectMappers.mapCreateProject(mutaion.data || {}),
  }

  return muationResult
}

export default useHook
